import React, { useEffect } from "react";
import NoDataFound from "../common/NoDataFound";
import GolfListTable from "./GolfListTable";
import { uniqueId } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const GolfLeagueMatches = ({
    data,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath = "golf",
    type = "golf",
    sport = "golf",
    dictionary = {},
}) => {

    useEffect(() => {
        if (loadCSS === "true") {
            loadStyles("golf");
        }
    }, [loadCSS]);

    return (
        <div className="golf_listing">
            {data?.length ? (
                data?.map((tour, ind) => (<GolfListTable data={tour} key={uniqueId(ind)} index={ind} websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath} sport={sport} difference={difference} dataClient={dataClient} />)

                )
            ) : (
                <NoDataFound text={type === true ? 'There are no live games currently in progress' : 'No matches found'} />
            )}
        </div>
    );
};

export default GolfLeagueMatches;


